import loadAlmeHistory from '../components/AlmeApp/initialize/loadAlmeHistory';
import { getLastResponseExtensionData } from '../components/AlmeResponse/AlmeResponseExt';
import { getCurrentAppState } from './../components/AlmeApp/AlmeAppState';
import useRecursiveTimeout from './useRecursiveTimeout';
export function usePollForHistory(almeState, setAlmeState, appConfig, almeApiUtils, history) {
    useRecursiveTimeout(async () => {
        var _a;
        if (history.length && !almeState.sessionExpired) {
            const curAppState = getCurrentAppState();
            const lastResponse = history[history.length - 1];
            const lastEntryId = (_a = lastResponse === null || lastResponse === void 0 ? void 0 : lastResponse.extensionData) === null || _a === void 0 ? void 0 : _a.entryId;
            const currentLastEntryId = curAppState === null || curAppState === void 0 ? void 0 : curAppState.lastEntryId;
            if (lastEntryId !== currentLastEntryId && lastResponse.responseRevision > 0) {
                const newHistory = await loadAlmeHistory(almeApiUtils);
                const extData = getLastResponseExtensionData(newHistory);
                setAlmeState(Object.assign(Object.assign({}, almeState), { history: newHistory, historyLoaded: true, lastEntryId: extData === null || extData === void 0 ? void 0 : extData.entryId, chatId: extData === null || extData === void 0 ? void 0 : extData.chatId, launchQuestion: undefined }));
            }
        }
    }, appConfig.lastEntryIdInterval);
}
